import { makeAutoObservable } from 'mobx';
import APIService, { IActiveGroup } from '../services/APIService';
import { SETTINGS_TABS } from '../constants';
export const activeGroupIdKey = '__$ag';
export const activeGroupScroll = '__$agc';
class SettingsStore {
    public activeGroupId: string = null;
    public overrideActiveCountries: number[] = null;
    public activeTab: SETTINGS_TABS;
    public activeGroups: IActiveGroup[];

    constructor() {
        makeAutoObservable(this);
    }
    public setActiveGroupId(id: string) {
        if (this.activeGroupId === id) {
            return;
        }
        this.activeGroupId = id;
        APIService.reconnectWebSocketTransport(true);
    }

    public setActiveTab(tab: SETTINGS_TABS) {
        this.activeTab = tab;
    }

    public setOverrideActiveCountries(c: number[]) {
        this.overrideActiveCountries = c;
    }
    public setActiveGroups(groups: IActiveGroup[]) {
        this.activeGroups = groups;
    }
}
export default new SettingsStore();
